import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MedicineService } from 'src/core/services/medicine.service';
import { PermissionsService } from 'src/core/services/permissions.service';
import { UtilsService } from 'src/core/services/utils.service';
import { DosageType, DosageUnit, EditMedicineDosageTypePayload, MedicineDosageType, PackageType } from 'src/interfaces/medicine';

@Component({
  selector: 'core-medicine-dosage-types-list',
  templateUrl: './medicine-dosage-types-list.component.html',
  styleUrls: ['./medicine-dosage-types-list.component.scss']
})
export class MedicineDosageTypesListComponent implements OnInit {

  @Input() medicineDosageTypes: MedicineDosageType[];
  @Input() dosageTypes: DosageType[] = [];
  @Input() packageTypes: PackageType[] = [];
  @Input() dosageUnits: DosageUnit[] = [];
  @Input() medicineId: number;
  @Output() onMedicineDosageTypeUpdated = new EventEmitter<boolean>();

  displayedColumns: string[] = [
    'name',
    'dosage_type',
    'created',
    'actions'
  ];

  // pagination state
  page: number = 1;
  limit: number = 10;
  total: number = 0;

  constructor(
    private _medicineService: MedicineService,
    public utilsService: UtilsService,
    public readonly perm: PermissionsService,
  ) { }

  ngOnInit(): void {
    this.total = this._medicineService.getTotalNumberOfMedicineDosageTypes();
  }

  getDosageType(medicineDosageType: MedicineDosageType) {
    const dosageType = this.dosageTypes.find(type => type.id === medicineDosageType.dosage_type_id);
    return dosageType ? dosageType.type : "";
  }

  viewDetails(medicineDosageType: MedicineDosageType) {

  }

  async edit(medicineDosageType: MedicineDosageType) {
    const success: boolean = await this._medicineService
      .openMedicineDosageTypeEditDialog(
        "Edit medicine dosage type",
        "Edit medicine dosage type",
        medicineDosageType,
        this.medicineId,
        this.dosageTypes,
        this.packageTypes,
        this.dosageUnits
      )
    this.onMedicineDosageTypeUpdated.emit(success);
  }

  async delete(medicineDosageType: MedicineDosageType) {
    const success: boolean = await this._medicineService
      .deleteMedicineDosageType(
        this.medicineId, medicineDosageType.id);

    if (success) {
      this.medicineDosageTypes = this.medicineDosageTypes
        .filter(_medicineDosageType => _medicineDosageType.id !== medicineDosageType.id);
    }

  }

  async activate(medicineDosageType: MedicineDosageType) {
    const payload: EditMedicineDosageTypePayload = {
      additional_information: medicineDosageType.additional_information,
      usage_instructions: medicineDosageType.usage_instructions,
      storage_directions: medicineDosageType.storage_directions,
      special_instructions: medicineDosageType.special_instructions,
      dosage_strength: medicineDosageType.dosage_strength,
      dosage_type_id: medicineDosageType.dosage_type_id,
      is_active: true
    }
    const activatedMedicineDosageType: boolean = await this._medicineService
      .editMedicineDosageType(
        this.medicineId,
        medicineDosageType.id,
        payload
      );

    if (activatedMedicineDosageType) {
      medicineDosageType.is_active = true;
    }
  }

  async deActivate(medicineDosageType: MedicineDosageType) {

    const payload: EditMedicineDosageTypePayload = {
      additional_information: medicineDosageType.additional_information,
      usage_instructions: medicineDosageType.usage_instructions,
      storage_directions: medicineDosageType.storage_directions,
      special_instructions: medicineDosageType.special_instructions,
      dosage_strength: medicineDosageType.dosage_strength,
      dosage_type_id: medicineDosageType.dosage_type_id,
      is_active: false
    }
    const activatedMedicineDosageType: boolean = await this._medicineService
      .editMedicineDosageType(
        this.medicineId,
        medicineDosageType.id,
        payload
      );

    if (activatedMedicineDosageType) {
      medicineDosageType.is_active = false;
    }
  }

  async onPageChange(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;
    await this.loadPage();
  }

  async prevPage() {
    if (this.page <= 1) return;
    this.page = this.page - 1;
    await this.loadPage();
  }

  async nextPage() {
    if (this.page >= this.lastPage) return;
    this.page = this.page + 1;
    await this.loadPage();
  }

  get lastPage(): number {
    return this.total > 0 ? Math.ceil(this.total / this.limit) : 1;
  }

  private async loadPage() {
    if (!this.medicineId) return;
    this.medicineDosageTypes = await this._medicineService
      .getMedicineDosageTypes(this.medicineId, this.page, this.limit, '');
    this.total = this._medicineService.getTotalNumberOfMedicineDosageTypes();
  }

}
